import React, { SVGProps } from 'react';

export const DoubleCheckIcon: React.FC<SVGProps<SVGSVGElement>> = ({
  width = 35,
  height = 20,
  ...props
}) => {
  return (
    <svg
      fill="none"
      height={height}
      viewBox="0 0 35 20"
      width={width}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M26.4796 2.10291L24.357 0L14.8129 9.45563L16.9355 11.5585L26.4796 2.10291ZM32.8624 0L16.9355 15.7793L10.643 9.56003L8.52043 11.6629L16.9355 20L35 2.10291L32.8624 0ZM0 11.6629L8.41505 20L10.5376 17.8971L2.13763 9.56003L0 11.6629Z"
        fill="currentColor"
      />
    </svg>
  );
};
